import 'component/adaptive-video'

class HHVideoHero extends HTMLElement {
  constructor() {
    super()

    this.audioButton?.addEventListener(
      'click',
      this.onClickAudioButton.bind(this)
    )

    this.linkOverlays.forEach((link) =>
      link.addEventListener('click', this.onOverlayLinkClick.bind(this))
    )
  }

  onClickAudioButton() {
    const mutted = this.audioButton.getAttribute('data-mode') == 'mute'
    const targetMode = mutted ? 'play' : 'mute'
    this.audioButton.setAttribute('data-mode', targetMode)
    this.audioIcons.forEach((icon) => {
      const mode = icon.getAttribute('data-mode')
      if (mode == targetMode) {
        icon.classList.remove('hidden')
      } else {
        icon.classList.add('hidden')
      }
    })
    this.videoElement?.handleToggleAudio()
  }

  onOverlayLinkClick(event) {
    const video = this.heroVideo
    // First tap on a linked banner starts the video instead of navigating.
    // Once it's playing, the tap falls through and the link works normally.
    if (video && video.paused) {
      event.preventDefault()
      video.play()
    }
  }

  get videoElement() {
    return this.querySelector('hh-adaptive-video')
  }

  get heroVideo() {
    return this.videoElement?.videoElement ?? null
  }

  get linkOverlays() {
    return this.querySelectorAll('.video-hero__full-link, a.hero-overlay')
  }

  get audioButton() {
    return this.querySelector('.js-audio-button')
  }

  get audioIcons() {
    return this.querySelectorAll('.js-audio-icon')
  }
}

if (!customElements.get('hh-video-hero')) {
  customElements.define('hh-video-hero', HHVideoHero)
}